<template>
    <div>
        <b-btn @click="printOrders" class="ml-3" variant="link" :disabled="progressing">
            <span class="text-link" v-if="!progressing">
                Print Tab List...
            </span>
            <span v-else>
                Please wait...
            </span>
            <!--            <font-awesome-icon icon="print" class="align-middle mx-2"/>-->
        </b-btn>
        <vue-easy-print ref="easyPrint">
            <template slot-scope="func">
                <b-container>
                    <b-table-simple striped class="w-100 special-table">
                        <b-thead>
                            <b-tr>
                                <b-td colspan="8">
                                    <div class="text-center">
                                        <p>
                                            {{info.RestaurantName}}, {{info.RestaurantAddress}}
                                        </p>
                                        <p class="mb-0">Special Event: {{choosedMenuType.MenuType}}      Tabs: {{items.length}} active
                                            <span v-if="canceledItem.length">
                                                , {{canceledItem.length}} canceled
                                            </span>
                                        </p>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>No</b-th>
                                <b-th>Tab No</b-th>
                                <b-th>Type</b-th>
                                <b-th>Status</b-th>
                                <b-th>Pay</b-th>
                                <b-th>Name</b-th>
                                <b-th>Submitted</b-th>
                                <b-th>Due</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in items" :key="index" class="border-bottom-0">
                                <b-td>{{index + 1}}</b-td>
                                <b-td>{{item.TabNo}}</b-td>
                                <b-td>{{item.OrderType}}</b-td>
                                <b-td>{{item.OrderStatus}}</b-td>
                                <b-td>{{item.PaymentStatus}}</b-td>
                                <b-td>{{item.CustomerName}}</b-td>
                                <b-td>{{$convertDate(item.OrderDate)}}</b-td>
                                <b-td>{{$convertDate(item.DueTime)}}</b-td>
                                <b-tr>
                                    <b-td></b-td>
                                    <b-td colspan="7">
                                        <div v-for="(child, index) in item.Items.RestaurantOrderDetails" :key="index">
                                            <div>
                                                {{child.Quantity + 'x'}}
                                                <span class="ml-1">
                                                    {{child.ItemName}}
                                                </span>
                                                <span style="color: #3d5afe !important" v-if="child.Alcoholic" class="font-weight-bold mx-5">
                                                    * ALC. VERIFY AGE *
                                                </span>
                                            </div>
                                            <div class="text-danger ml-4">
                                                {{child.PriceComment}}
                                            </div>
                                            <div class="font-weight-bold ml-4" style="color: red">
                                                {{child.Modifiers}}
                                            </div>
                                            <div class="text-danger ml-4 font-weigth-bold">
                                                {{child.Description}}
                                            </div>
                                        </div>
                                    </b-td>
                                </b-tr>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-container>
            </template>
        </vue-easy-print>
    </div>
</template>

<script>
    import vueEasyPrint from "vue-easy-print";

    export default {
        name: "printSpecialOrder",
        components: {
            vueEasyPrint
        },
        props: {
            filter: {required: true},
            menuTypes: {required: true},
            menuTypeId: {required: true}
        },
        data () {
            return {
                progressing: false,
                items: [],
                info: {}
            }
        },
        computed: {
            canceledItem () {
                return this.items && this.items.filter(i => i.OrderStatusID === 5)
            },
            choosedMenuType () {
                return this.menuTypes.find(item => item.MenuTypeID === this.menuTypeId)
            }
        },
        methods: {
            printOrders () {

                const filter = this.filter
                filter.IsLive = 1
                filter.Serve_Type = ""
                this.progressing = true
                return this.$api.getRestaurant.GetRestaurantOrdersDetailedList(filter).then(res => {
                    this.progressing = false
                    if (res.success) {
                        this.items = res.results.RestaurantOrders
                        this.info = res.results
                        this.$nextTick(() => {
                            this.$refs.easyPrint.print()
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    @media print {
        *{
            background: #fff !important;
        }
    }
    /*.printOrders{*/
    /*    display: none;*/
    /*}*/

    /*@media print {*/
    /*    .printOrders{*/
    /*        display: block;*/
    /*    }*/
    /*}*/
</style>
